const PREFIX = 'abtest';

export function isInBucket(name, value) {
	return getBucket(name) === value;
}

export function getBucket(name) {
	if (!name) return '';

	let re = new RegExp('(?:^|;)\\s*'+PREFIX+name+'=((?:[^;]|$)*)'),
		cookieMatch = document.cookie.match(re);
	return cookieMatch ? cookieMatch[1] : '';
}
